import React from "react";
import { ButtonToolbar } from "react-bootstrap";

import CustomButton from "../../components/custom-button";
import ActivityFeedList from "./activity-feed-container";
import {
  ActivityFeedScopeProvider,
  useActivityFeedScope,
} from "./activity-feed-scope-context";
import ActivityFeedTypeFilter from "./activity-feed-type-filter";
import ActivityFeedDateFilter from "./activity-feed-date-filter";
import { CUSTOMER_TYPE_LABELS } from "./activity-feed-customer-utils";
import "../prospect/dashboard/prospect-dashboard.css";
import "./activity-feed.css";

const ActivityFeedDrawerBody = ({ customerType, close, customerFilter }) => {
  const {
    initialized,
    activityTypeCategory,
    setActivityTypeCategory,
    startDate,
    endDate,
    setDateRange,
  } = useActivityFeedScope();

  const label = CUSTOMER_TYPE_LABELS[customerType] || customerType;
  const scopedCustomerLabel = customerFilter?.label;

  return (
    <>
      <div className="form_TitleContainer">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ margin: "0 1.1rem" }}
        >
          <div>
            <div className="form_Title">{label}</div>
            <div className="form_TitleBig mt-1">
              <h2>
                {scopedCustomerLabel
                  ? `Activity Feed for ${scopedCustomerLabel}`
                  : `Activity Feed`}
              </h2>
            </div>
          </div>
          <div className="d-flex pr-3">
            <ButtonToolbar>
              {close && (
                <CustomButton
                  color="black"
                  className="form_CancelButton"
                  onClick={close}
                  btnValue="CLOSE"
                />
              )}
            </ButtonToolbar>
          </div>
        </div>
      </div>

      <div className="form_body activity-feed-drawer-body">
        <div
          id="dashboard-header-container"
          className="d-flex flex-wrap align-items-end dashboard-header-wrapper activity-feed-filters z4 mb-3"
        >
          <div className="activity-feed-filter-item mr-4 mb-2">
            <ActivityFeedTypeFilter
              value={activityTypeCategory}
              onChange={setActivityTypeCategory}
            />
          </div>
          <div className="activity-feed-filter-item activity-feed-date-filter-item mb-2">
            <ActivityFeedDateFilter
              startDate={startDate}
              endDate={endDate}
              onChange={setDateRange}
            />
          </div>
        </div>

        {initialized && (
          <div className="activity-feed-list-section">
            <ActivityFeedList
              customerType={customerType}
              cardTitle={`Activity Feed ${customerType}${
                scopedCustomerLabel ? ` ${scopedCustomerLabel}` : ""
              }`}
            />
          </div>
        )}
      </div>
    </>
  );
};

/**
 * Activity Feed side drawer — same shell as create/edit drawers.
 */
const ActivityFeedDrawer = ({ customerType, close, customerFilter }) => (
  <ActivityFeedScopeProvider
    customerFilter={customerFilter}
    key={
      customerFilter?.customerIds?.length
        ? customerFilter.customerIds.join(",")
        : "all-customers"
    }
  >
    <div className="activity-feed-drawer-root">
      <ActivityFeedDrawerBody
        customerType={customerType}
        close={close}
        customerFilter={customerFilter}
      />
    </div>
  </ActivityFeedScopeProvider>
);

export default ActivityFeedDrawer;
